import { Fragment, useState } from "react";
import { Btn, Modal, Field, Inp, Sel, Txta, Empty, Card, FormRow, Stage, Chips, Selo, ExpandTable, Detalhe } from "../components/primitives";

const IMPACTO_TONE = { Alto: "bad", "Médio": "warn", Baixo: "ok" };

// ── ConcorrenteFormModal ──────────────────────────────────────────────────────
function ConcorrenteFormModal({ initial, clients, onClose, onSave }) {
  const [f, setF] = useState(initial || {
    nome: "", nicho: "", instagram: "", bio: "", nome_perfil: "", link_bio: "",
    estilo_feed: "", frequencia_postagem: "", linguagem: "", autoridade_percebida: "",
    tipos_postagem: "", cta_utilizados: "", padroes_conteudo: "", diferencial: "",
    publico_alvo: "", sensacao_transmitida: "", observacao_geral: "",
    imagem_perfil_url: "", imagem_feed_url: "", client_ids: [],
  });
  const up = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const [saving, setSaving] = useState(false);

  function toggleClient(id) {
    const ids = f.client_ids || [];
    up("client_ids", ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id]);
  }

  const canSave = f.nome.trim() && (f.client_ids || []).length > 0;

  async function save() {
    if (!canSave) return;
    setSaving(true);
    await onSave(f);
    setSaving(false);
  }

  return (
    <Modal title={initial ? "Editar concorrente" : "Novo concorrente"} onClose={onClose} width={580}>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>

        <div>
          <div style={{ fontSize: 11, fontWeight: 700, color: "var(--faint)", textTransform: "uppercase", letterSpacing: ".06em", marginBottom: 8 }}>
            Clientes vinculados *
          </div>
          {(!clients || clients.length === 0) ? (
            <div style={{ fontSize: 13, color: "var(--faint)" }}>Nenhum cliente cadastrado.</div>
          ) : (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {clients.map((cl) => {
                const checked = (f.client_ids || []).includes(cl.id);
                return (
                  <label
                    key={cl.id}
                    style={{
                      display: "flex", alignItems: "center", gap: 6,
                      padding: "5px 10px", borderRadius: 6, cursor: "pointer",
                      border: `1.5px solid ${checked ? "var(--primary)" : "var(--line-soft)"}`,
                      background: checked ? "var(--primary-soft)" : "var(--surface)",
                      fontSize: 13, color: checked ? "var(--primary)" : "var(--ink)",
                      fontWeight: checked ? 600 : 400, userSelect: "none",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={() => toggleClient(cl.id)}
                      style={{ display: "none" }}
                    />
                    {cl.name}
                  </label>
                );
              })}
            </div>
          )}
          {(f.client_ids || []).length === 0 && (
            <div style={{ fontSize: 11, color: "var(--danger)", marginTop: 4 }}>Selecione pelo menos um cliente.</div>
          )}
        </div>

        <FormRow>
          <Field label="Nome" half><Inp value={f.nome} onChange={(e) => up("nome", e.target.value)} /></Field>
          <Field label="Nicho" half><Inp value={f.nicho || ""} onChange={(e) => up("nicho", e.target.value)} /></Field>
        </FormRow>
        <FormRow>
          <Field label="Instagram (@)" half><Inp value={f.instagram || ""} onChange={(e) => up("instagram", e.target.value)} /></Field>
          <Field label="Link da bio" half><Inp value={f.link_bio || ""} onChange={(e) => up("link_bio", e.target.value)} /></Field>
        </FormRow>
        <Field label="Bio"><Txta rows={2} value={f.bio || ""} onChange={(e) => up("bio", e.target.value)} /></Field>
        <FormRow>
          <Field label="Estilo de feed" half><Inp value={f.estilo_feed || ""} onChange={(e) => up("estilo_feed", e.target.value)} /></Field>
          <Field label="Frequência de post" half><Inp value={f.frequencia_postagem || ""} onChange={(e) => up("frequencia_postagem", e.target.value)} /></Field>
        </FormRow>
        <FormRow>
          <Field label="Linguagem" half><Inp value={f.linguagem || ""} onChange={(e) => up("linguagem", e.target.value)} /></Field>
          <Field label="Autoridade percebida" half><Inp value={f.autoridade_percebida || ""} onChange={(e) => up("autoridade_percebida", e.target.value)} /></Field>
        </FormRow>
        <Field label="Diferencial"><Txta rows={2} value={f.diferencial || ""} onChange={(e) => up("diferencial", e.target.value)} /></Field>
        <Field label="Público-alvo"><Inp value={f.publico_alvo || ""} onChange={(e) => up("publico_alvo", e.target.value)} /></Field>
        <Field label="Sensação transmitida"><Inp value={f.sensacao_transmitida || ""} onChange={(e) => up("sensacao_transmitida", e.target.value)} /></Field>
        <Field label="Observação geral"><Txta rows={2} value={f.observacao_geral || ""} onChange={(e) => up("observacao_geral", e.target.value)} /></Field>
        <FormRow>
          <Field label="Imagem perfil (URL)" half><Inp value={f.imagem_perfil_url || ""} onChange={(e) => up("imagem_perfil_url", e.target.value)} /></Field>
          <Field label="Imagem feed (URL)" half><Inp value={f.imagem_feed_url || ""} onChange={(e) => up("imagem_feed_url", e.target.value)} /></Field>
        </FormRow>
        <Btn variant="accent" full onClick={save} disabled={saving || !canSave}>{saving ? "Salvando..." : "Salvar"}</Btn>
      </div>
    </Modal>
  );
}

// ── ConcorrenteDetail ─────────────────────────────────────────────────────────
function ConcorrenteDetail({ concorrente, clients, analises, criativos, onUpdate, onNewAnalise, onNewCriativo }) {
  const [tab, setTab]             = useState("geral");
  const [editing, setEditing]     = useState(false);
  const [showAnalise, setShowAnalise]   = useState(false);
  const [showCriativo, setShowCriativo] = useState(false);
  const [analise, setAnalise] = useState({ categoria: "", observacao: "", impacto: "Médio", aplicavel: true });
  const [criativoForm, setCriativoForm] = useState({ nome: "", tipo: "Reels", hook: "", estrategia: [], cta: "", copy: "", legenda: "", observacao: "", ideia_adaptavel: "", imagem_url: "" });

  const tabs = [
    { id: "geral",      label: "Visão Geral" },
    { id: "estrategia", label: "Análise Estratégica" },
    { id: "criativos",  label: "Criativos Observados" },
  ];

  return (
    <div className="table-card" style={{ padding: "18px 20px" }}>
      <div className="tab-bar">
        <div style={{ minWidth: 0 }}>
          <div style={{ font: "700 18px var(--font-display)", color: "var(--ink)" }}>{concorrente.nome}</div>
          <div className="sub" style={{ color: "var(--faint)", fontSize: 12.5 }}>
            {[concorrente.nicho, concorrente.instagram && `@${concorrente.instagram}`].filter(Boolean).join(" · ")}
          </div>
        </div>
        <Btn sm variant="secondary" onClick={() => setEditing(true)}>Editar</Btn>
      </div>

      <Chips label="Seções do concorrente" items={tabs.map((t) => ({ ...t, count: t.id === "estrategia" ? analises.length : t.id === "criativos" ? criativos.length : undefined }))} active={tab} onChange={setTab} />

      <div style={{ paddingTop: 16 }}>
        {tab === "geral" && (
          <div style={{ display: "grid", gap: 12 }}>
            <dl className="facts">
            {[
              { l: "Bio",                  v: concorrente.bio },
              { l: "Estilo de feed",       v: concorrente.estilo_feed },
              { l: "Frequência de post",   v: concorrente.frequencia_postagem },
              { l: "Linguagem",            v: concorrente.linguagem },
              { l: "Autoridade percebida", v: concorrente.autoridade_percebida },
              { l: "Tipos de postagem",    v: concorrente.tipos_postagem },
              { l: "CTAs utilizados",      v: concorrente.cta_utilizados },
              { l: "Padrões de conteúdo",  v: concorrente.padroes_conteudo },
              { l: "Diferencial",          v: concorrente.diferencial },
              { l: "Público-alvo",         v: concorrente.publico_alvo },
              { l: "Sensação transmitida", v: concorrente.sensacao_transmitida },
              { l: "Observação geral",     v: concorrente.observacao_geral },
            ].filter((x) => x.v).map((x) => (
              <Fragment key={x.l}><dt>{x.l}</dt><dd>{x.v}</dd></Fragment>
            ))}
            </dl>
            {concorrente.imagem_feed_url && (
              <img src={concorrente.imagem_feed_url} alt="feed" style={{ width: "100%", maxHeight: 200, objectFit: "cover", borderRadius: 14 }} />
            )}
          </div>
        )}

        {tab === "estrategia" && (
          <div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
              <Btn sm variant="accent" onClick={() => setShowAnalise(!showAnalise)}>+ Adicionar</Btn>
            </div>
            {showAnalise && (
              <Card style={{ padding: "14px 16px", marginBottom: 14, background: "var(--bg)" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  <FormRow>
                    <Field label="Categoria" half><Inp value={analise.categoria} onChange={(e) => setAnalise({ ...analise, categoria: e.target.value })} /></Field>
                    <Field label="Impacto" half>
                      <Sel value={analise.impacto} onChange={(e) => setAnalise({ ...analise, impacto: e.target.value })}>
                        {["Alto","Médio","Baixo"].map((v) => <option key={v}>{v}</option>)}
                      </Sel>
                    </Field>
                  </FormRow>
                  <Field label="Observação"><Txta rows={2} value={analise.observacao} onChange={(e) => setAnalise({ ...analise, observacao: e.target.value })} /></Field>
                  <Btn sm variant="accent" onClick={async () => { await onNewAnalise(analise); setShowAnalise(false); setAnalise({ categoria:"",observacao:"",impacto:"Médio",aplicavel:true }); }}>Salvar</Btn>
                </div>
              </Card>
            )}
            {analises.length === 0 ? <Empty icon="📊" text="Nenhuma análise estratégica registrada." /> : (
              <div className="klist">
                {analises.map((a) => (
                  <div key={a.id} className="klist-row">
                    <span className="txt"><strong style={{ fontWeight: 600 }}>{a.categoria || "Sem categoria"}</strong>{a.observacao && <span style={{ color: "var(--muted)" }}> · {a.observacao}</span>}</span>
                    {a.impacto && <Selo tone={IMPACTO_TONE[a.impacto] || "off"}>{a.impacto}</Selo>}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {tab === "criativos" && (
          <div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
              <Btn sm variant="accent" onClick={() => setShowCriativo(!showCriativo)}>+ Adicionar</Btn>
            </div>
            {showCriativo && (
              <Card style={{ padding: "14px 16px", marginBottom: 14, background: "var(--bg)" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  <FormRow>
                    <Field label="Nome" half><Inp value={criativoForm.nome} onChange={(e) => setCriativoForm({ ...criativoForm, nome: e.target.value })} /></Field>
                    <Field label="Tipo" half>
                      <Sel value={criativoForm.tipo} onChange={(e) => setCriativoForm({ ...criativoForm, tipo: e.target.value })}>
                        {["Reels","Carrossel","Estático","Story"].map((v) => <option key={v}>{v}</option>)}
                      </Sel>
                    </Field>
                  </FormRow>
                  <Field label="Hook"><Txta rows={2} value={criativoForm.hook} onChange={(e) => setCriativoForm({ ...criativoForm, hook: e.target.value })} /></Field>
                  <FormRow>
                    <Field label="CTA" half><Inp value={criativoForm.cta} onChange={(e) => setCriativoForm({ ...criativoForm, cta: e.target.value })} /></Field>
                    <Field label="Ideia adaptável" half><Inp value={criativoForm.ideia_adaptavel} onChange={(e) => setCriativoForm({ ...criativoForm, ideia_adaptavel: e.target.value })} /></Field>
                  </FormRow>
                  <Field label="Observação"><Txta rows={2} value={criativoForm.observacao} onChange={(e) => setCriativoForm({ ...criativoForm, observacao: e.target.value })} /></Field>
                  <Field label="URL da imagem"><Inp value={criativoForm.imagem_url} onChange={(e) => setCriativoForm({ ...criativoForm, imagem_url: e.target.value })} placeholder="https://..." /></Field>
                  <Btn sm variant="accent" onClick={async () => { await onNewCriativo(criativoForm); setShowCriativo(false); }}>Salvar</Btn>
                </div>
              </Card>
            )}
            {criativos.length === 0 ? <Empty icon="🎬" text="Nenhum criativo observado." /> : (
              <ExpandTable
                minWidth={480}
                rows={criativos}
                columns={[
                  { key: "hook", label: "Criativo", render: (cc) => <span className="name">{cc.hook || cc.nome}</span> },
                  { key: "tipo", label: "Tipo", render: (cc) => cc.tipo ? <Selo tone="off" dot={false}>{cc.tipo}</Selo> : <span className="sub">—</span> },
                ]}
                detail={(cc) => (
                  <div className="detail-grid">
                    {cc.imagem_url && <img src={cc.imagem_url} alt={cc.nome} style={{ maxWidth: 260, width: "100%", borderRadius: 14 }} />}
                    <Detalhe label="CTA">{cc.cta}</Detalhe>
                    <Detalhe label="Ideia adaptável">{cc.ideia_adaptavel}</Detalhe>
                    <Detalhe label="Observação" pre>{cc.observacao}</Detalhe>
                  </div>
                )}
              />
            )}
          </div>
        )}
      </div>

      {editing && (
        <ConcorrenteFormModal
          initial={concorrente}
          clients={clients}
          onClose={() => setEditing(false)}
          onSave={async (data) => { await onUpdate(concorrente.id, data); setEditing(false); }}
        />
      )}
    </div>
  );
}

// ── ConcorrentesView (exported) ───────────────────────────────────────────────
export function ConcorrentesView({ clients, concorrentes, analises, criativosConcorrentes, onNew, onUpdate, onNewAnalise, onNewCriativoConcorrente }) {
  const [selected, setSelected] = useState(null);
  const [showForm, setShowForm] = useState(false);

  return (
    <div className="view">
      <Stage
        path="concorrentes"
        title="Mapa de"
        hl="concorrentes"
        lead={<>{concorrentes.length} mapeados</>}
        actions={<Btn sm variant="primary" onClick={() => setShowForm(true)}>+ Novo</Btn>}
      />

      <div style={{ display: "flex", gap: 20, alignItems: "flex-start", flexWrap: "wrap" }}>
        <div style={{ flex: "1 1 260px", maxWidth: 360, minWidth: 0 }}>
          {concorrentes.length === 0 ? (
            <Empty icon="◎" text="Nenhum concorrente mapeado." />
          ) : (
            <div className="klist">
              {concorrentes.map((c) => {
                const vinc = (c.client_ids || []).map((id) => (clients || []).find((x) => x.id === id)?.name).filter(Boolean);
                const on = selected?.id === c.id;
                return (
                  <div
                    key={c.id}
                    className="klist-row"
                    role="button"
                    tabIndex={0}
                    aria-pressed={on}
                    onClick={() => setSelected(c)}
                    onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setSelected(c); } }}
                    style={{ cursor: "pointer", background: on ? "var(--primary-soft)" : undefined }}
                  >
                    <span className="txt">
                      <span style={{ fontWeight: 600 }}>{c.nome}</span>
                      <span style={{ display: "block", color: "var(--faint)", fontSize: 12.5, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {[c.nicho, vinc.join(", ")].filter(Boolean).join(" · ") || (c.instagram ? `@${c.instagram}` : "")}
                      </span>
                    </span>
                    <span className="chev" aria-hidden="true" style={{ color: "var(--faint)" }}>›</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {selected && (
          <div style={{ flex: 1, minWidth: 0 }}>
            <ConcorrenteDetail
              concorrente={selected}
              clients={clients}
              analises={analises.filter((a) => a.concorrente_id === selected.id)}
              criativos={criativosConcorrentes.filter((cc) => cc.concorrente_id === selected.id)}
              onUpdate={onUpdate}
              onNewAnalise={(data) => onNewAnalise({ ...data, concorrente_id: selected.id })}
              onNewCriativo={(data) => onNewCriativoConcorrente({ ...data, concorrente_id: selected.id })}
            />
          </div>
        )}
      </div>

      {showForm && (
        <ConcorrenteFormModal
          clients={clients}
          onClose={() => setShowForm(false)}
          onSave={async (data) => { await onNew(data); setShowForm(false); }}
        />
      )}
    </div>
  );
}
